import React from "react";
import Navbar from "../../components/base/landing/navbar";
import FooterLanding from "../../components/base/landing/footer";
import Cursos from "../../components/base/landing/cursos";
import WhatsApp from "../../components/base/whatsapp";
import BlogButton from "../../components/base/blog";


const CursosPage = () => {
    return (
      <>
        <Navbar />
        <Cursos/>
        <FooterLanding/>
        <BlogButton/>
        <WhatsApp/>
      </>
    );
  };
  
  export default CursosPage;

